import styled from 'styled-components';
import { MarginProps } from 'styled-system';

import { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { Box } from 'components/Box';
import { TrackedPrimaryButtonLink } from 'components/Button';
import { Body } from 'components/Text/Body';
import { H2 } from 'components/Text/H2';
import { Tile } from 'components/Tile';
import { colors } from 'theme';

export const CmsTwoTilesBlockTile = styled(
  ({
    buttonText,
    buttonUrl,
    className,
    dataQaPrefix,
    headline,
    text,
    blockIndex,
    pageUpdated,
    ...props
  }: {
    buttonText: string;
    buttonUrl: string;
    className?: string;
    dataQaPrefix: string;
    headline: string;
    text: string;
    image?: ApiFilestackImageData;
    blockIndex: number;
    pageUpdated: string;
  }) => (
    <Tile
      position="relative"
      display="flex"
      p={['20px', null, '60px']}
      alignItems="center"
      justifyContent="stretch"
      flexDirection="column"
      flex="1"
      overflow="hidden"
      textAlign="center"
      className={className}
      data-qa-prefix={dataQaPrefix}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <H2 m="0">{headline}</H2>
      <Box mt="20px" width="100%" flex="1 1 auto">
        <Body
          analyticsData={{
            eventName: 'CMS Block',
            eventProperties: {
              block_position: blockIndex,
              block_type: 'Two Tiles',
            },
          }}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </Box>
      {buttonText && buttonUrl && (
        <Box mt={['32px', null, '52px']} width="100%">
          <TrackedPrimaryButtonLink
            href={buttonUrl}
            eventName="CMS Block"
            eventProperties={{
              block_position: blockIndex,
              block_type: 'Two Tiles',
              cta_type: 'Button',
              button_text: buttonText,
              page_updated: pageUpdated,
            }}
          >
            {buttonText}
          </TrackedPrimaryButtonLink>
        </Box>
      )}
    </Tile>
  ),
)<MarginProps>`
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 10px;
    background-image: linear-gradient(
      to left,
      ${colors.skyBlue},
      ${colors.brandBlue}
    );
    background-size: 100% 10px;
    background-repeat: no-repeat;
  }
`;
